// 路由名称常量
export const ROUTE_NAMES = {
  LOGIN: 'Login',
  SEARCH: 'Search',
  ADD: 'Add',
  LIVE: 'Live',
  USER_MANAGEMENT: 'UserManageMent',
  UPDATE: 'Update',
  SHOW: 'Show',
  MEMO: 'Memo',
  FILE: 'File',
  HELLO_WORLD: 'HelloWorld',
  INVENTORY: 'Inventory',
  DETAIL: 'Detail'
}

// 路由路径常量
export const ROUTE_PATHS = {
  LOGIN: '/login',
  SEARCH: '/search',
  ADD: '/add',
  LIVE: '/live',
  USER_MANAGEMENT: '/user',
  UPDATE: '/update',
  SHOW: '/show',
  MEMO: '/memo',
  FILE: '/file',
  HELLO_WORLD: '/hello',
  INVENTORY: '/inventory',
  DETAIL: '/detail'
}

// 路由元信息
export const ROUTE_META = {
  REQUIRES_AUTH: 'requiresAuth',
  TITLE: 'title',
  PERMISSIONS: 'permissions'
}



// WEBPACK FOOTER //
// ./src/constants/routes.js